import {sweetAPI} from 'app/store/sweet-api';
import {showLoadingBar, showMessages} from 'app/store/sweet-api/utils';
import {VIDEO_API} from 'app/urls';
import {
  DEFAULT_OPTS,
  EMBEDLY_OEMBED_API_URL,
  oEmbedType,
} from 'app/utils/embedly';
import {gt} from 'app/utils/i18n';
import {VIDEO_TAG} from 'app/utils/rtk-tags';

import type {VideoSerializedType} from 'sweet-types';

export const extendedAPI = sweetAPI
  .enhanceEndpoints({addTagTypes: [VIDEO_TAG]})
  .injectEndpoints({
    endpoints: (build) => ({
      video: build.query<VideoSerializedType, {hashid: string}>({
        query: (params = {hashid: ''}) => ({
          url: `${VIDEO_API}${params.hashid}/`,
        }),
        onQueryStarted: (args, api) => {
          showLoadingBar(args, api);
          showMessages({
            onError: () => gt('Unable to load video.'),
          })(args, api);
        },
      }),
      oembed: build.query<oEmbedType, {key: string; url: string}>({
        query: (params) => ({
          url: EMBEDLY_OEMBED_API_URL,
          params: {...DEFAULT_OPTS, ...params},
        }),
        transformResponse: (response: oEmbedType) => {
          if (
            response.provider_url === 'https://screencast-o-matic.com' &&
            response.type === 'link'
          ) {
            // link looks like https://screencast-o-matic.com/watch/cqf2rbZYj4
            const parts = response.url.split('/');
            const code = parts[parts.length - 1].match(/[a-zA-Z0-9]+/);

            if (code == null) {
              // invalid code don't trust.
              return response;
            }

            return {
              type: 'video',
              html: `<iframe frameborder="0" scrolling="no" src="https://screencast-o-matic.com/embed?sc=${code[0]}&v=5&ff=1" allowfullscreen="true"></iframe>`,
              // placeholder isn't used.
              width: 1280,
              // placeholder isn't used.
              height: 868,
              title: '',
              version: response.version,
              provider_url: response.provider_url,
              provider_name: response.provider_name,
            };
          }

          return response;
        },
      }),
    }),
  });

// https://redux-toolkit.js.org/rtk-query/usage/queries#hook-types
export const {useLazyVideoQuery: useLazyVideo, useOembedQuery: useOembed} =
  extendedAPI;
